module.exports = __webpack_public_path__ + "static/logomark-construction-24907d47fcfeb9051d9f5646d8160e18.png";